import { IMonthCalendarEvent } from '@/components/month-calendar/types/IMonthCalendarEvent';
import useAuth from '@/hooks/useAuth';
import usePureState from '@/hooks/usePureState';
import timezoneService from '@/services/timezone.service';
import IBookingRules from '@/types/IBookingRules';
import { useIsFetching, useIsMutating } from '@tanstack/react-query';
import { DateTime } from 'luxon';
import { useTranslation } from 'react-i18next';
import { Temporal } from 'temporal-polyfill';

export interface IProps {
	bookingRules: IBookingRules;
	onChange: (values: Partial<IBookingRules>) => void;
}

export function useSectionPTO(props: IProps) {
	// TODO: Be more specific
	const isLoading = useIsFetching() > 0;
	const isMutating = useIsMutating() > 0;
	const { t } = useTranslation();
	const auth = useAuth();
	// FIXME
	const timeZone = timezoneService.getTimeZone();

	const { state, dispatch } = usePureState({
		busyIntervals: props.bookingRules.busyIntervals,
		from: DateTime.now(),
	});

	function addEventToCalendar(e: { start: Temporal.PlainDate; end: Temporal.PlainDate }) {
		const start = e.start.toZonedDateTime(timeZone).toInstant().toString();
		// Asumimos que queremos estar ocupados todo el día
		const end = e.end
			.toZonedDateTime(timeZone)
			.with({ hour: 23, minute: 59, second: 59, millisecond: 999 })
			.toInstant()
			.toString();

		const busyIntervals = [...(props.bookingRules.busyIntervals ?? []), { start, end }];
		props.onChange({ busyIntervals });
		dispatch({ busyIntervals });
	}

	function removeEventFromCalendar(e: IMonthCalendarEvent) {
		const busyIntervals =
			props.bookingRules.busyIntervals?.filter(
				(interval) =>
					!Temporal.Instant.from(interval.start).equals(e.start.toInstant()) &&
					!Temporal.Instant.from(interval.end).equals(e.end.toInstant())
			) ?? [];
		props.onChange({ busyIntervals });
		dispatch({ busyIntervals });
	}

	return {
		dispatch,
		isLoading,
		isMutating,
		auth,
		t,
		state,
		timeZone,
		removeEventFromCalendar,
		addEventToCalendar,
	};
}
